import React, { useContext } from 'react';
import { bool, string } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { StorePodContext } from '../StorePod.context';
import { StorePodLoader } from './StorePodLoader';

export const StorePodAddress = ({ displaySingleLine, height }) => {
  const { loading, store } = useContext(StorePodContext);
  const {
    city,
    postalCode,
    state,
    street
  } = store?.address || {};

  if (loading) {
    return (
      <div data-testid="store-pod-address-loader">
        <StorePodLoader height="2rem" />
        {!displaySingleLine && <StorePodLoader height="2rem" />}
      </div>
    );
  }

  return (
    <div>
      {!displaySingleLine && (
        <>
          <div className="sui-overflow-hidden sui-text-ellipsis sui-whitespace-nowrap">
            <Typography height={height}>{street}</Typography>
          </div>
          <div className="sui-overflow-hidden sui-text-ellipsis sui-whitespace-nowrap">
            <Typography height={height}>{city}, {state} {postalCode}</Typography>
          </div>
        </>
      )}
      {displaySingleLine && (
        <div className="sui-overflow-hidden sui-text-ellipsis sui-whitespace-nowrap">
          <Typography height={height}>{street}, {city}, {state} {postalCode}</Typography>
        </div>
      )}
    </div>
  );
};

StorePodAddress.propTypes = {
  displaySingleLine: bool,
  height: string
};

StorePodAddress.defaultProps = {
  displaySingleLine: false,
  height: 'tight'
};

StorePodAddress.displayName = 'StorePodAddress';
